module.exports = __webpack_public_path__ + "media/images/emblems/Beatenberg-coat_of_arms-4ceb809cd2f2272cdb065d1965387adc.svg";